import { useAppSelector } from "@/hooks/hook";
import { format } from "date-fns";
import { convertStripeTime, Loader } from "@thdinc/hpf-shared";
import React, { FC, useEffect } from "react";
interface BillingHistoryItem {
  name: string;
  amount: number;
  status: 'paid' | 'open';
  create_at: string;
  stripe_time: number;
}

// Update Props to use the specific type for history
interface Props {
  getBillingHistory?: () => void;
  isLoading?: boolean;
  history?: BillingHistoryItem[] | null; // Match the type of history state
}

export const BillingList: FC<Props> = ({ getBillingHistory = () => { console.log('getBillingHistory called') }, isLoading = false, history = [] }) => {
  const businessId = useAppSelector((store) => store.business);
  useEffect(() => {
    getBillingHistory();
  }, [businessId.currentBusiness]);

  return (
    <div className="bg-white  p-4 rounded-2xl w-full mt-10">
      <p className="font-semibold text-xl">Past Billing</p>
      <div className="mt-4 flex gap-10 flex-wrap">
        {isLoading ? (
          <div className="mt-5 w-full">
            <Loader color="bg-primary-red" />
          </div>
        ) : history && history?.length > 0 ? (
          history.map((_, i) => {
            return (
              <div
                key={i}
                className="flex flex-col sm:flex-row justify-between gap-4 sm:gap-9 text-sm items-start sm:items-center bg-gray-100 p-4 rounded-xl w-full sm:w-fit"
              >
                <div>
                  <p className="font-semibold">Name</p>
                  <p className="text-gray-500">{_.name}</p>
                </div>
                <div>
                  <p className="font-semibold">Date</p>
                  <p className="text-gray-500">
                    {format(convertStripeTime(_.stripe_time), "MM-dd-yyyy")}
                  </p>
                </div>
                <div>
                  <p className="font-semibold">Amount</p>
                  <p className="text-gray-500">${_.amount / 100}</p>
                </div>
                <p className={`${_.status === "open" ? "bg-primary-red" : "bg-green-400"} rounded-full text-xs py-1 text-white w-[74px] text-center`}>
                  {_.status === "open" ? "Declined" : "Paid"}
                </p>
              </div>
            );
          })
        ) : (
          <div className="text-center  w-full text-gray-400">
            <p>No Billing History</p>
          </div>
        )}
      </div>
    </div>
  );
};
